import { createFileRoute, Link } from '@tanstack/react-router'
import appsComingSoon from '~/assets/illustrations/apps_coming_soon.svg'
import { Button } from '~/components/ui/button'
import { ScrollArea } from '~/components/ui/scroll-area'

export const Route = createFileRoute('/app/')({
	component: AppHome,
})

function AppHome() {
	return (
		<ScrollArea>
			<main className="container-fluid py-[48px]">
				{/* Main content box */}
				<div className="container-fluid relative mx-auto w-full max-w-content border py-[48px]">
					<div className="absolute top-[24px] right-[24px] bg-yellow-100 px-[4px] font-semibold text-[12px] text-navy-100">Coming soon</div>
					<div className="flex flex-col items-center gap-[48px]">
						<div className="flex flex-col items-center gap-[24px]">
							{/* Illustration */}
							<img
								src={appsComingSoon}
								aria-hidden
							/>

							{/* Text content */}
							<div className="flex w-full flex-col items-center gap-[18px] text-center">
								<h1 className="font-display font-medium text-[30px] text-navy-100">Spark Apps is coming in 2026</h1>
								<div className="text-[18px] text-dark-grey-100">
									<p className="pb-[48px]">A growing library of AI apps designed by UniMelb staff, for UniMelb staff.</p>
									<p className="pb-[24px] italic">Can't find the app that you need?</p>
									<p>
										Build your own in <span className="font-bold">AI Studio</span> and launch it into <span className="font-bold">Spark Apps.</span>
									</p>
								</div>
							</div>
						</div>

						{/* Buttons */}
						<div className="flex gap-[8px]">
							<Button
								variant="outline"
								size="md"
							>
								<a
									href="https://forms.office.com/r/qufVjnUbe3"
									target="_blank"
									rel="noopener noreferrer"
								>
									Submit an app concept
								</a>
							</Button>

							<Button
								variant="primary"
								size="md"
							>
								<Link to="/studio">AI Studio</Link>
							</Button>
						</div>
					</div>
				</div>
			</main>
		</ScrollArea>
	)
}
